// src/components/Common/ProtectedRoute.js
import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import {
  Box,
} from '@mui/material';
import { AuthContext } from '../../context/AuthContext';
import SigertreLoader from '../../components/Common/SigertreLoader'; // Importar el componente reutilizable

const ProtectedRoute = ({ roles }) => {
  const { user, loading } = useContext(AuthContext);

    if (loading) {
      return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 4 }}>
           <SigertreLoader
              loaderText="SIGERTRE"
              message="Cargando..."
              sx={{
                  '& .MuiTypography-root': { color: 'text.secondary', fontSize: '1.1rem', mt: 2 }
              }}
           />
        </Box>
      );
  }

  // Verifica que el usuario exista y que su rol esté incluido en la lista de roles permitidos
  if (user && roles.includes(user.role)) {
    return <Outlet />;
  } else {
    return <Navigate to="/unauthorized" replace />;
  }
};

export default ProtectedRoute;
